"use client";

import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "next-i18next";
import parse from "html-react-parser";

export default function Main() {
  const videoRef = useRef(null);
  const [buttonHover, setButtonHover] = useState(false);
  const { t } = useTranslation("main");

  useEffect(() => {
    if (!videoRef.current) return;
    const videoElement = videoRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!videoElement) return;
        if (entry.isIntersecting) {
          videoElement.play().catch(() => {});
        } else {
          videoElement.pause();
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(videoElement);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      id="home"
      className="scroll-mt-16 pt-20 relative w-screen md:min-h-screen flex flex-col items-center justify-center bg-reefliBeige"
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="relative w-[90vw] h-[50vh] sm:h-[70vh] xl:h-[70vh] rounded-4xl overflow-hidden shadow-lg"
      >
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover"
        >
          <source src="/img/reefli_video_short.mp4" type="video/mp4" />
        </video>

        <div
          className={`absolute inset-0 transition-all duration-300 z-10 ${
            buttonHover ? "bg-black/50" : "bg-black/20"
          }`}
        />

        <div className="absolute z-20 bottom-6 left-1/2 transform -translate-x-1/2">
          <Link href="/video" scroll={false}>
            <button
              onMouseEnter={() => setButtonHover(true)}
              onMouseLeave={() => setButtonHover(false)}
              className="relative overflow-hidden px-5 py-2 rounded-full shadow-md text-sm sm:text-small font-semibold bg-white text-[#262104] group border-2 border-white"
            >
              <span className="relative z-10 transition-colors duration-300 group-hover:text-white">
                {t("button")}
              </span>
              <span className="absolute inset-0 bg-[#b99878] z-0 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-in-out rounded-full" />
            </button>
          </Link>
        </div>
      </motion.div>

      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
        className="mt-6 px-4 text-center font-[futura] text-xl sm:text-2xl md:text-3xl text-[#262104] max-w-[90%] sm:max-w-[80%] leading-snug"
      >
        {t("headline1")}
        <b>
          REEFLI
          <span className="align-super text-[0.65em] font-sans ml-0.5">™</span>
        </b>{" "}
        {t("headline2")}
      </motion.h1>
    </div>
  );
}
